import {
    SkeletonAvatar,
    SkeletonButton,
    SkeletonText,
} from '@neshane/blueberry';

import styles from './PageLoader.module.css';

export const PageLoader = () => {
    return (
        <div data-testid="PageLoader">
            <div className={styles.headerGrid}>
                <SkeletonAvatar variant="square" />
                <div className={styles.headerContainer}>
                    <SkeletonButton />
                    <SkeletonButton />
                    <SkeletonButton />
                </div>
            </div>
            <div className={styles.divider} />
            <div className={styles.layoutContainer}>
                <SkeletonText className="col-span-2 col-start-2" size="xxl" />
                <SkeletonText className="mt-24" size="l" />
                <SkeletonText className="mt-16" size="l" />
                <SkeletonText className="mt-16" size="l" />
                <SkeletonText className="mt-16" size="l" />
                <SkeletonButton className="mt-24" />
            </div>
        </div>
    );
};